import { Field } from "formik";
import { registerWidget } from "./registry";
import { getClassName } from "./utils";

export const checkboxFormField = (config: any, formikParams: any) => {
  const extraProps = config ?? {};
  if (formikParams.handleChange != null)
    extraProps["onChange"] = formikParams.handleChange;
  if (formikParams.readOnly != null)
    extraProps["readOnly"] = formikParams.readOnly;
  return (
    <Field
      {...extraProps}
      key={config.key ?? config.name}
      name={config.name}
      type={config.type}
      onInvalid={(e: any) => e.target.setCustomValidity('Your custom message')} 
      className={`form-check form-check-none ${getClassName(config)}`}
      required={undefined}
      id={config.name}
    />
  );
};

registerWidget("checkbox", checkboxFormField);
